import {doc} from '../docs.js';
import JakiSnapshots from '../../custom/JakiSnapshots.js';

doc(
    "jsnapshot",
    {
    },
    "Takes snapshots of the jaki object parameters to be recalled and sequenced",
    () => 0,
    {
        inlets: 0
    });
export const jsnapshot = (object) => {
    let snap = new JakiSnapshots(object);
    return () => {
    };
};
